"use client";
import { Card, Placeholder } from "react-bootstrap";

const QuestionsPlaceholder = () => {
  return (
    <div className="questions-placeholder-container">
      {[...Array(3)].map((_, index) => (
        <Card key={index} className="mb-4 p-3 shadow-sm">
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={8} />
          </Placeholder>

          <div className="mt-3">
            {[...Array(4)].map((_, i) => (
              <Placeholder
                key={i}
                as="p"
                animation="glow"
                className="mb-2 rounded"
              >
                <Placeholder xs={10} />
              </Placeholder>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default QuestionsPlaceholder;
